import { render, staticRenderFns } from "./ImagePuzzle.vue?vue&type=template&id=2dd7ad0a&scoped=true&"
import script from "./ImagePuzzle.vue?vue&type=script&lang=js&"
export * from "./ImagePuzzle.vue?vue&type=script&lang=js&"
import style0 from "./ImagePuzzle.vue?vue&type=style&index=0&id=2dd7ad0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd7ad0a",
  null
  
)

export default component.exports